//解密Java DES/CBC/PKCS5Padding usesIv = true
// 工作在使用AES使用有betwheen PKCS＃5 & PKCS＃7没有区别。
// PKCS＃5和PKCS＃7填充之间的区别是它支持的块大小。 PKCS＃5仅适用于8字节块，而PKCS＃7适用于块大小介于1和255字节之间的块。 AES使用8字节的块大小。
const CryptoJS = require('crypto-js');  //引用AES源码js
export const Decrypt = (word, inkey) => {
	const key = CryptoJS.enc.Utf8.parse(inkey);
	let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
	let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
	let decrypt = CryptoJS.DES.decrypt(srcs, key, { iv: key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
	let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
	console.log('!!!', decryptedStr.toString(), 'ss');
	return decryptedStr.toString() || '解密失败';
}



// WEBPACK FOOTER //
// ./src/utils/des.js